import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService, PrimeIcons } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ActivatedRoute } from '@angular/router';
import { OdaAtFirestore } from 'src/app/models/odaAtFirestore.model';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { environment } from 'src/environments/environment';
import { onSnapshot } from 'firebase/firestore';
import { UtilService } from 'src/app/services/util.service';
import { Menu } from 'primeng/menu';

import { ExcelService } from 'src/app/services/excelService.service';
import { StiliService } from 'src/app/services/stili.service';
import { UserService } from 'src/app/services/user.service';
import { Location } from "@angular/common";


import { ProntofibraService } from 'src/app/services/prontofibra.service';
import { FiltroProntofibra, Prontofibra_Firestore } from 'src/app/models/prontofibra.firestore.model';
import { v4 as uuidv4 } from 'uuid';
import { ImportLog_Firestore } from 'src/app/models/firestore/importLogFirestore.model';
import { StoricoPFComponent } from './storico/storico-pf.component';
import { ListeService } from 'src/app/services/liste.service';
import { forkJoin } from 'rxjs';
import { DialogModificaPF } from './modifica-stato/modifica_pf.component';
import { ImpreseService } from 'src/app/services/imprese.service';
import { Impresa } from 'src/app/models/impresa.model';
import { DialogModificaDataInstallazioneRouter } from '../shared/modifica-data-installazione-router/modifica_data_installazione_router.component';
import { DialogModificaCategoriaKOProntofibra } from './modifica-categoria/modifica_categoria';
import { StoricoNotePraticaComponent } from '../shared/note-pratica/note-pratica.component';
import { PraticheService } from 'src/app/services/pratiche.service';
import { CategoriaVincolo } from 'src/app/models/categoriaVincolo.model';
import { PraticaFlowdy2_Firestore } from 'src/app/models/praticaFirestore.model';

declare const CSVBoxImporter: any;

@Component({
    templateUrl: './prontofibra.component.html',
    styleUrls: ['./prontofibra.component.css'],
    providers: [DialogService, ConfirmationService],

})
export class ProntofibraComponent implements OnInit, OnDestroy {
    protected isLoadingResults:boolean = false;
    protected mostraprontofibraCompletate:boolean = false;

    protected showSollecitaConfirmation:boolean = false;
    protected showSollecitaMassivamenteConfirmation:boolean = false;
     
    public isAdmin: boolean                     = false;
    public isSuperAdmin: boolean                = false;
    public isPresidioSF: boolean                = false;
    public isPresidioTIM: boolean               = false;
    public isDirigenteFirmaVerbali: boolean     = false;
    public isDirigenteFirmaPacchetti: boolean   = false;
    public isPM:boolean                         = false;
    public isContabile:boolean                  = false;
    public isImpresa:boolean                    = false;
    public isDemo: boolean                      = false;
    protected prontofibra:Prontofibra_Firestore[] ;
    protected prontofibraFiltrati:Prontofibra_Firestore[] ;
    protected selectedProntofibra:Prontofibra_Firestore ;
   
    private importID: string; 

    protected numeroInAttesa:number = 0;

    @ViewChild("menuAzioni", { static: true }) azioniMenu: Menu;
    @ViewChild("menuAzioniTiered", { static: true }) azioniMenuTiered: Menu;

    protected menuAzioniItems!: MenuItem[];

    private _filtroprontofibra!: FiltroProntofibra;

    private collection_prontofibra:string = environment.firebase.collection_prontofibra;
    private collection_importLog:string = environment.firebase.collection_import_log;
    private collection_pratiche:string = environment.firebase.collection_pratiche;

    private ref: DynamicDialogRef;

    protected filterTabellaIsSet:boolean = false;
    
    protected filterIsSet:boolean = false;
    protected filtroLotto:String;
    protected filtroStato:String;
    protected filtroStatoDecodificato:String;
    protected filtroBando:String;
    protected filtroInLavorazione:Boolean=false;
    protected filtroPratica:String;

    private csvbox_licenseKey_aggiornaPF:string=environment.csvBox.secret_aggiornaPF;
    private csvbox_importer_aggiornamentoPF:any;

    protected categorieVincolo:CategoriaVincolo[]=[];


    @ViewChild("prontofibraDT", { static: true }) prontofibraDT: any;
    
    protected imprese:Impresa[]=[];
    protected impreseBando1:Impresa[]=[];
    protected impreseBando2:Impresa[]=[];
    
    constructor(
        private logger: NGXLogger,
        public firestore: AngularFirestore,
        public utilService:UtilService,
        protected stiliService:StiliService,
        private userService:UserService,
        public dialogService: DialogService,
        private messageService: MessageService,
        private prontofibraService:ProntofibraService,
        private excelService:ExcelService,
        private activatedRoute: ActivatedRoute,
        private location: Location,
        private listeService:ListeService,
        private aziendeService: ImpreseService,
        private praticheService:PraticheService,

    ) {
      this._filtroprontofibra = {};
      this.setUserRole();
      this.loadImprese();
      this.loadCategorieVincolo();
    }
    loadCategorieVincolo() {
      this.utilService.getCategorieAppuntamentoKO().subscribe((categorieVincolo) => {
        this.categorieVincolo = categorieVincolo;
      
      });
    }
    loadImprese() {
        this.aziendeService.get().subscribe((aziende) => {
          this.imprese = aziende;
          
      });
    }

    ngOnDestroy(): void {
    }

    ngOnInit() {
      this.initCSVBox();
        this.activatedRoute.queryParamMap.subscribe((params) => {
        this.filtroBando         = params.get('bando') ;
        this.filtroStato         = params.get('stato') ;
        this.filtroInLavorazione = params.get('in-lavorazione') === 'true';
        this.filtroPratica       = params.get('pratica');
        if(this.filtroStato){
          this.filtroStatoDecodificato = decodeURIComponent(this.filtroStato.valueOf());

        }
        this.filtroLotto         = params.get('lotto') ;
        if(this.filtroStato || this.filtroBando  || this.filtroInLavorazione || this.filtroPratica){
          this.filterIsSet          = true;
        }
        
      //  this.logger.info("PF CON FILTRO "+ this.filtroBando + " "+ this.filtroStato + " "+ this.filtroLotto + " ---> "+ this.filterIsSet + " & "+ this.filterTabellaIsSet);
      });
     
     
      this.loadProntofibra();
    }

    initCSVBox(){
      this.csvbox_importer_aggiornamentoPF = new CSVBoxImporter(this.csvbox_licenseKey_aggiornaPF, {
      }, (result: boolean, data: any) => {
        if (result) {
          this.readImportLog();
         
        } else {
          this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di aggiornamento dei prontofibra', life:10000});
        }
      });
      
      this.csvbox_importer_aggiornamentoPF.setUser({
        user_id: "default123"
      });
      
     
      this.csvbox_importer_aggiornamentoPF.language="it";
    }

    readImportLog(){
      const collectionRef = this.firestore.collection(this.collection_importLog).ref;
      let queryErrori ;
      queryErrori = collectionRef
                .where("id", "==", this.importID);
      
      onSnapshot(queryErrori, (qs) => {
        this.isLoadingResults = false;
        qs.forEach((doc) => {
            let log: ImportLog_Firestore = doc.data() as ImportLog_Firestore;

            if(!log.errori || log.errori.length == 0){
              this.messageService.add({severity:'success', summary:'', detail: log.numeroRecordProcessati + ' PRONTOFIBRA processati con successo!', life:10000});
            }else{
              this.messageService.add({severity:'info', summary:'Errore', detail:'Il caricamento dei PRONTOFIBRA si è concluso con '+ log.numeroRecordNonProcessati +' errori', life:10000});
            }
       
          });
      });  
    }

    
    async openCaricaAzioni( event: any, prontofibra:Prontofibra_Firestore ): Promise<void> {
      this.selectedProntofibra = prontofibra;
      this.loadAzioni(event, prontofibra);
      this.azioniMenuTiered.toggle(event);
    }

    visualizzaNote(prontofibra: Prontofibra_Firestore) {
      this.isLoadingResults = true;
      this.praticheService.getByCUI(prontofibra.cui).subscribe(pratica=>{
        if(pratica){
          this.praticheService.getNote(pratica.id).subscribe(notePratica=>{
            this.isLoadingResults = false;
            this.ref = this.dialogService.open(StoricoNotePraticaComponent, {
              data: {
                pratica: pratica,
                note: notePratica,
              },
              header: "NOTE della pratica "+pratica.cui,
              width: "50%",
              height: "85%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
          });
        }else{
          this.messageService.add({severity:'info', summary:'Attenzione', detail:'Pratica non trovata', life:10000});
          this.isLoadingResults = false;
        }
       
      });
      
    }

   
    loadAzioni(event:any, prontofibra:Prontofibra_Firestore){
      this.menuAzioniItems = [];
      this.menuAzioniItems.push({
        label: "Storico",
        icon: PrimeIcons.HISTORY,
        style: {'font-size': '12px'},
        command: () => this.openStoricoprontofibra(prontofibra),
        },
      );
      if(this.isAdmin || this.isSuperAdmin || this.isPresidioSF || this.isDemo){
        this.menuAzioniItems.push({
          label: "Note",
          icon: 'icona-note-presidio',
          style: {'font-size': '12px'},
          command: () => this.visualizzaNote(prontofibra),
          },
        );
        this.menuAzioniItems.push({
          label: "Modifica stato",
          icon: "icona-edit_stato",
          style: {'font-weight': 'bold', 'font-size': '12px'},
          command: () => this.modificaPF(prontofibra),
          disabled: this.isDemo
          },
        );
       /*  if(prontofibra.codiceStatoProntofibra == "KO"){
          this.menuAzioniItems.push({
            label: "Categoria KO",
            icon: "icona-edit_causa_ko",
            style: {'font-weight': 'bold', 'font-size': '11.8px'},
            command: () => this.openModificaCategoriaKO(prontofibra),
            },

          );
        } */
        if(prontofibra.codiceStatoProntofibra == "IN ATTESA"){
          this.menuAzioniItems.push({
            label: "Sollecita",
            icon: "icona-sollecita",
            style: {'font-weight': 'bold', 'font-size': '12px'},
            command: () => this.openSollecitaProntofibra(prontofibra),
            disabled: this.isDemo
            },
          );
        
         /*  this.menuAzioniItems.push({
            label: "Modifica stato",
            icon: "icona-pf_pronto",
            style: {'font-size': '12px'},
            command: () => this.openComunicaProntofibraisReady(prontofibra),
            },

          ); */
        }

       /*  if(prontofibra.codiceStatoProntofibra == "ROUTER INSTALLATO"){
          this.menuAzioniItems.push({
            label: "Modifica Data Attiv.",
            icon: 'icona-modifica-data_attivazione',
            style: { 'font-weight': 'bold',  'font-size': '11.7px'},
            command: () => this.modificaDataAttivazione(prontofibra),
          });
        } */

        
        }
    
      
     
      
    }

    modificaDataAttivazione(prontofibra: Prontofibra_Firestore) {
      this.ref = this.dialogService.open(DialogModificaDataInstallazioneRouter, {
        data: {
          prontofibra: prontofibra,
        },
        header: "Cambiamento data installazione router del prontofibra "+prontofibra.cui,
        width: "40%",
        height: "35%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((invioFase1) => {
        if (invioFase1 && invioFase1.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Data installazione router del prontofibra modificato con successo!', life:3000});
        }
      }); 
    }

    importaPF(){
      this.importID = uuidv4();
      this.csvbox_importer_aggiornamentoPF.setUser({
        importID: this.importID,
      });
      this.csvbox_importer_aggiornamentoPF.openModal();
    }

    openModificaCategoriaKO(prontofibra: Prontofibra_Firestore){
      this.ref = this.dialogService.open(DialogModificaCategoriaKOProntofibra, {
        data: {
          prontofibra: prontofibra,
        },
        header: "Aggiorna la CAUSA del KO del prontofibra "+prontofibra.cui,
        width: "55%",
        height: "57%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((invioFase1) => {
        if (invioFase1 && invioFase1.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Causa del KO del prontofibra indicata con successo!', life:3000});
        }
      }); 
    }

    async getPratica(cui:string):Promise<PraticaFlowdy2_Firestore | null>{
      const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
      let query = collectionRef.where("cui", "==", cui);
      
      return new Promise((resolve) => {
        onSnapshot(query, (qs) => {
          if (qs.empty) {
            resolve(null);
            return;
          }
          qs.forEach((doc) => {
            const pratica = doc.data() as PraticaFlowdy2_Firestore;
            resolve(pratica);
          });
        });
      });
    }
    async modificaPF(prontofibra: Prontofibra_Firestore){
      //this.isLoadingResults = true;
      let pratica = await this.getPratica(prontofibra.cui.toString());
      if(pratica){
        //this.isLoadingResults = false;
        this.logger.info(pratica);
        if(!pratica.vincoloTipologiaID){
          this.ref = this.dialogService.open(DialogModificaPF, {
            data: {
              prontofibra: prontofibra,
            },
            header: "Cambiamento stato del prontofibra "+prontofibra.cui,
            width: "70%",
            height: "40%",
            baseZIndex: 10000,
            closable: true,
            draggable: false,
          });
          this.ref.onClose.subscribe((invioFase1) => {
            if (invioFase1 && invioFase1.success) {
              this.messageService.add({severity:'success', summary:'', detail:'Stato del prontofibra modificato con successo!', life:3000});
            }
          });  
        }else{
          this.messageService.add({severity:'warn', summary:'Attenzione', detail:'Impossibile modificare lo stato del PF di una pratica ancora in KO!', life:3000});
        }
      }else{
        this.messageService.add({severity:'error', summary:'Attenzione', detail:'Pratica '+prontofibra.cui.toString()+' non trovata', life:3000});
        //this.isLoadingResults = false;
      }

      /* */
    }

    openSollecitaProntofibra(prontofibra: Prontofibra_Firestore){
      this.selectedProntofibra = prontofibra;
      this.showSollecitaConfirmation = true;
    }

    confermaSollecitaPF(){
      this.isLoadingResults = true;

      this.prontofibraService.sollecita(this.selectedProntofibra.id.toString()).subscribe( {
        next: (v) => {
          this.isLoadingResults = false;
          this.messageService.add({severity:'success', summary:'', detail:'Prontofibra sollecitato!', life:5000});
          this.showSollecitaConfirmation = false;
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di sollecito del prontofibra'});
            this.isLoadingResults = false;
            this.showSollecitaConfirmation = false;
        },
        complete: () => {
         
        }
      });
    }

    openStoricoprontofibra(prontofibra: Prontofibra_Firestore) {
       this.isLoadingResults = true;
       this.prontofibraService.getStorico(prontofibra.id.toString()).subscribe(storicoprontofibra=>{
        this.isLoadingResults = false;
          if(storicoprontofibra && storicoprontofibra.length > 0){
            this.logger.info(storicoprontofibra);
            this.ref = this.dialogService.open(StoricoPFComponent, {
              data: {
                prontofibra: prontofibra,
                storicoProntofibra: storicoprontofibra
              },
              header: "Storico del prontofibra "+prontofibra.cui,
              width: "50%",
              height: "60%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
          }else{
            this.messageService.add({
              severity: "info",
              summary: "Attenzione!",
              detail: "Il prontofibra non presenta STORICO",
            });
          }
      });  
    }

   
   
    onMostraAttivatiChange(newValue: boolean): void {
      this.mostraprontofibraCompletate = newValue
      this.loadProntofibra();
    }

    getSollecitoTooltip(prontofibra:Prontofibra_Firestore):string{
      if(prontofibra.dataUltimoSollecito){
        return 'Ultimo sollecito in data '+ this.utilService.formattaDataDaTimestampFirestore(prontofibra.dataUltimoSollecito);
      }
      return '';
    }
    getDataInstallazioneRouterTooltip(prontofibra:Prontofibra_Firestore):string{
      if(prontofibra.dataInstallazioneRouter){
        return 'Router installato in data '+ this.utilService.formattaDataDaTimestampFirestore(prontofibra.dataInstallazioneRouter);
      }
      return '';
    }

    getDataMancataInstallazioneRouterTooltip(prontofibra:Prontofibra_Firestore):string{
      if(prontofibra.dataInstallazioneRouter){
        return 'Tentativo fallito di installazione del router in data '+ this.utilService.formattaDataDaTimestampFirestore(prontofibra.dataInstallazioneRouter);
      }
      return '';
    }

    getDataConfermaAttivazioneTooltip(prontofibra:Prontofibra_Firestore):string{
      if(prontofibra.dataConfermaTS){
        return 'Attivazione confermata da TS in data '+ this.utilService.formattaDataDaTimestampFirestore(prontofibra.dataConfermaTS);
      }
      return '';
    }

    getCategoriaKOAbbreviata(prontofibra:Prontofibra_Firestore):string{
      if(prontofibra.categoriaKO){
        if(prontofibra.categoriaKO.startsWith("Problema")){
          return "P." + prontofibra.categoriaKO.replace("Problema", "").trim();
        }else if (prontofibra.categoriaKO.startsWith("Cassetto")) {
          return "Cass." + prontofibra.categoriaKO.replace("Cassetto", "").trim();
        } else if (prontofibra.categoriaKO === "Causa Cliente") {
          return prontofibra.categoriaKO;
        }
      }
      return prontofibra.categoriaKO;
    }

    getTipoSedeAbbreviata(prontofibra:Prontofibra_Firestore):string{
      if(prontofibra.bando ==='BANDO 1'){
        if(prontofibra.tipoSede.startsWith("M")){
          return "Mand. "+prontofibra.tipoSede.charAt(prontofibra.tipoSede.length-1);
  
        }else{
          return "Agg. "+prontofibra.tipoSede.charAt(prontofibra.tipoSede.length-1);
        }
      }else{
        return prontofibra.tipoSede;
      }
    }
    getTipoSedeEffettivaAbbreviata(prontofibra:Prontofibra_Firestore):string{
      if(prontofibra.bando ==='BANDO 1'){
        if(prontofibra.tipoSede.startsWith("M")){
          return "Mand. "+prontofibra.tipoSedeEffettiva.charAt(prontofibra.tipoSedeEffettiva.length-1);
  
        }else{
          return "Agg. "+prontofibra.tipoSedeEffettiva.charAt(prontofibra.tipoSedeEffettiva.length-1);
        }
      }else{
        return prontofibra.tipoSedeEffettiva;
      }
    }
    
    loadProntofibra(){
        this.isLoadingResults = false;
        const collectionRef = this.firestore.collection(this.collection_prontofibra).ref;
        let query;
      if(this.isImpresa){
        if(this.filterIsSet){
          if(this.filtroLotto){
            if(this.filtroStato){
              this.logger.info("[PF] LOADING prontofibra per IMPRESA FILTRO PER LOTTO "+ this.filtroLotto + " E STATO "+  this.filtroStato);
              query= collectionRef
              .where("bando", "==", "BANDO "+this.filtroBando)
              .where("codiceStatoProntofibra", "==", decodeURIComponent(this.filtroStato.valueOf()) )
              .where("lotto", "==", this.filtroLotto)
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
              .orderBy("dataComunicazioneProntofibra");
            }else{
              this.logger.info("[PF] LOADING prontofibra per IMPRESA FILTRO PER BANDO "+ this.filtroBando +" E LOTTO "+ this.filtroLotto);
              query= collectionRef
              .where("bando", "==", "BANDO "+this.filtroBando)
              .where("lotto", "==", this.filtroLotto)
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
              .orderBy("dataComunicazioneProntofibra");
            }
           
          }else if(this.filtroBando && !this.filtroStato){
            if(!this.filtroInLavorazione){
              this.logger.info("[PF] LOADING ALL prontofibra per IMPRESA PER BANDO "+ this.filtroBando );
              query= collectionRef
              .where("bando", "==", "BANDO "+this.filtroBando)
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
              .orderBy("dataComunicazioneProntofibra");
            }else{
              this.logger.info("[PF] LOADING prontofibra IN LAVORAZIONE per IMPRESA PER BANDO "+ this.filtroBando );
              query= collectionRef
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
              .where("bando", "==", "BANDO "+this.filtroBando)
              .where("codiceStatoProntofibra", "!=", "SEDE ATTIVATA")
              .orderBy("codiceStatoProntofibra")
              .orderBy("dataComunicazioneProntofibra");
            }
         
          }else if(this.filtroBando && this.filtroStato){
            this.logger.info("[PF] LOADING prontofibra per IMPRESA PER BANDO "+ this.filtroBando +" E STATO "+  this.filtroStato);
            query= collectionRef
            .where("bando", "==", "BANDO "+this.filtroBando)
            .where("idAzienda", "==", this.userService.getUser().azienda.id)
            .where("codiceStatoProntofibra", "==", decodeURIComponent(this.filtroStato.valueOf()) )
            .orderBy("dataComunicazioneProntofibra");
          }
        }else{
          this.logger.info("[prontofibra ] LOADING prontofibra per IMPRESA SENZA FILTRI");

          if(!this.mostraprontofibraCompletate){
             query = collectionRef
             .where("idAzienda", "==", this.userService.getUser().azienda.id)
             .where("attivazioneConfermataDaTS", "!=", true)
             .orderBy("attivazioneConfermataDaTS", "desc")
             .orderBy("dataComunicazioneProntofibra");
              
            
          }else{
            query= collectionRef
            .where("idAzienda", "==", this.userService.getUser().azienda.id)
            .orderBy("dataComunicazioneProntofibra");
          }
        }
      }else if(this.isPresidioSF || this.isAdmin || this.isSuperAdmin || this.isDirigenteFirmaPacchetti || this.isDemo){
        if(this.filterIsSet){
          if(this.filtroLotto){
            if(this.filtroStato){
              this.logger.info("[PF] LOADING prontofibra FILTRO PER LOTTO "+ this.filtroLotto + " E STATO "+  this.filtroStato);
              query= collectionRef
              .where("bando", "==", "BANDO "+this.filtroBando)
              .where("codiceStatoProntofibra", "==", decodeURIComponent(this.filtroStato.valueOf()) )
              .where("lotto", "==", this.filtroLotto)
              .orderBy("dataComunicazioneProntofibra");
            }else{
              this.logger.info("[PF] LOADING prontofibra FILTRO PER BANDO "+ this.filtroBando +" E LOTTO "+ this.filtroLotto);
              query= collectionRef
              .where("bando", "==", "BANDO "+this.filtroBando)
              .where("lotto", "==", this.filtroLotto)
              .orderBy("dataComunicazioneProntofibra");
            }
           
          }else if(this.filtroBando && !this.filtroStato && !this.filtroPratica){
            if(!this.filtroInLavorazione){
              this.logger.info("[PF] LOADING ALL prontofibra PER BANDO "+ this.filtroBando + " @ "+ this.collection_prontofibra);
              query= collectionRef
              .where("bando", "==", "BANDO "+this.filtroBando)
              .orderBy("dataComunicazioneProntofibra");
            }else{
              this.logger.info("[PF] LOADING prontofibra IN LAVORAZIONE PER BANDO "+ this.filtroBando );
              query= collectionRef
              .where("bando", "==", "BANDO "+this.filtroBando)
              .where("codiceStatoProntofibra", "!=", "SEDE ATTIVATA")
              .orderBy("codiceStatoProntofibra")
              .orderBy("dataComunicazioneProntofibra");
            }
         
          }else if(this.filtroBando && this.filtroStato && !this.filtroPratica){
            this.logger.info("[PF] LOADING prontofibra PER BANDO "+ this.filtroBando +" E STATO "+  this.filtroStato);
            query= collectionRef
            .where("bando", "==", "BANDO "+this.filtroBando)
            .where("codiceStatoProntofibra", "==", decodeURIComponent(this.filtroStato.valueOf()) )
            .orderBy("dataComunicazioneProntofibra");
          }else if(!this.filtroBando && !this.filtroStato && this.filtroPratica){
            this.logger.info("[PF] LOADING prontofibra PER PRATICA "+ this.filtroPratica );
            query= collectionRef
            .where("cui", "==", this.filtroPratica);
          }
        }else{
          this.logger.info("[prontofibra ] LOADING prontofibra  SENZA FILTRI");

          if(!this.mostraprontofibraCompletate){
             query = collectionRef
             .where("attivazioneConfermataDaTS", "!=", true)
             .orderBy("attivazioneConfermataDaTS", "desc")
             .orderBy("dataComunicazioneProntofibra");
              
            
          }else{
            query= collectionRef
            //.where("attivazioneConfermataDaTS", "==", true)
            .orderBy("dataComunicazioneProntofibra");
          }
        }
      }

        onSnapshot(query, (qs) => {
          //this.logger.info("[prontofibra ] prontofibra  CARICATE "+ qs.docs.length);

          this.prontofibra = [];
          this.prontofibraFiltrati = [];
          this.numeroInAttesa = 0;
          this.isLoadingResults = false;
          qs.forEach((doc) => {
            let prontofibra = doc.data() as Prontofibra_Firestore;
           // this.logger.info("[PF] PRONTOFIBRA "+ prontofibra.cui + " "+ prontofibra.id);
            if(prontofibra.codiceStatoProntofibra==='IN ATTESA'){
              this.numeroInAttesa++;
            }
            this.prontofibra.push(prontofibra);
            this.prontofibraFiltrati.push(prontofibra);

           
          });
          this.filtraProntofibra(null);
        });
  
    }


    filtraProntofibra(event: any){
     
      if(event && event.target){
        this.prontofibraDT.filterGlobal(event.target.value, 'contains');
      }else {
        if(this._filtroprontofibra && Object.keys(this._filtroprontofibra).length !== 0){
          this.filterTabellaIsSet = true;
          this.prontofibraFiltrati = this.prontofibra.filter((prontofibra: Prontofibra_Firestore) => {
          //  this.logger.info("[PF] FILTRA PRONTOFIBRA CON FILTRI "+ JSON.stringify(this._filtroprontofibra.categoriaAttesa) + " Vs " + prontofibra.categoriaKO);

            if(
              ((this._filtroprontofibra.tipo?.length ?? 0 ) > 0  && (this._filtroprontofibra.tipo.indexOf(prontofibra.tipoSede) == -1 || this._filtroprontofibra.tipo.indexOf(prontofibra.tipoSedeEffettiva) == -1)) ||
              ((this._filtroprontofibra.statoProntofibra?.length ?? 0  > 0 ) &&  this._filtroprontofibra.statoProntofibra.indexOf(prontofibra.codiceStatoProntofibra) == -1  )   ||
              ((this._filtroprontofibra.statoFase1?.length ?? 0  > 0 ) &&  this._filtroprontofibra.statoFase1.indexOf(prontofibra.codiceStatoInfratelFase1) == -1  )  ||
              ((this._filtroprontofibra.statoFase2?.length ?? 0  > 0 ) &&  this._filtroprontofibra.statoFase2.indexOf(prontofibra.codiceStatoInfratelFase2) == -1  )  ||
              ((this._filtroprontofibra.bando?.length ?? 0  > 0 ) &&  this._filtroprontofibra.bando.indexOf(prontofibra.bando) == -1  )  ||
              ((this._filtroprontofibra.regione?.length ?? 0  > 0 ) &&  this._filtroprontofibra.regione.indexOf(prontofibra.regione) == -1  )  ||
              ((this._filtroprontofibra.impresa?.length ?? 0  > 0 ) &&  this._filtroprontofibra.impresa.indexOf(prontofibra.idAzienda) == -1 )  ||
              ((this._filtroprontofibra.categoriaAttesa?.length ?? 0  > 0 ) &&  this._filtroprontofibra.categoriaAttesa.indexOf(prontofibra.categoriaKO) == -1 )  
            ){
              return false;
            }

            return true;

          }); 
        }else{
          this.prontofibraFiltrati = this.prontofibra;
        }
      }
    }

    filtraPerStatoInfratel(statoInfratel:string){
      if(!this.filterTabellaIsSet){
        this.prontofibraDT.filterGlobal(statoInfratel, 'contains');
        this.filterTabellaIsSet = true;
      }else{
        this.prontofibraDT.clear();
        this.filterTabellaIsSet = false;
      }
    }

    
    filtraPerBando(bando:String){
      if(!this.filterTabellaIsSet){
        if(
         (!this._filtroprontofibra.tipo || !this._filtroprontofibra.tipo.length) && 
         (!this._filtroprontofibra.statoFase1 || !this._filtroprontofibra.statoFase1.length) &&
         (!this._filtroprontofibra.statoFase2 || !this._filtroprontofibra.statoFase2.length) &&
         (!this._filtroprontofibra.statoProntofibra || !this._filtroprontofibra.statoProntofibra.length) &&
         (!this._filtroprontofibra.bando || !this._filtroprontofibra.bando.length) &&
         (!this._filtroprontofibra.regione || !this._filtroprontofibra.regione.length) 
       ){
         this.prontofibraDT.filterGlobal(bando, 'contains');
         this.filterTabellaIsSet = true;
       }
     }else{
       this.prontofibraDT.clear();
       if(
         (!this._filtroprontofibra.tipo || !this._filtroprontofibra.tipo.length) && 
         (!this._filtroprontofibra.statoFase1 || !this._filtroprontofibra.statoFase1.length) &&
         (!this._filtroprontofibra.statoFase2 || !this._filtroprontofibra.statoFase2.length) &&
         (!this._filtroprontofibra.statoProntofibra || !this._filtroprontofibra.statoProntofibra.length) &&
         (!this._filtroprontofibra.bando || !this._filtroprontofibra.bando.length) &&
         (!this._filtroprontofibra.regione || !this._filtroprontofibra.regione.length) 
        ){
           this.filterTabellaIsSet = false;
       } 
     }
      

      
    }
    filtraPerAzienda(azienda:String){
      if(!this.filterTabellaIsSet){
         if(
          (!this._filtroprontofibra.tipo || !this._filtroprontofibra.tipo.length) && 
          (!this._filtroprontofibra.statoFase1 || !this._filtroprontofibra.statoFase1.length) &&
          (!this._filtroprontofibra.statoFase2 || !this._filtroprontofibra.statoFase2.length) &&
          (!this._filtroprontofibra.statoProntofibra || !this._filtroprontofibra.statoProntofibra.length) &&
          (!this._filtroprontofibra.bando || !this._filtroprontofibra.bando.length) &&
          (!this._filtroprontofibra.regione || !this._filtroprontofibra.regione.length) 
        ){
          this.prontofibraDT.filterGlobal(azienda, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.prontofibraDT.clear();
        if(
          (!this._filtroprontofibra.tipo || !this._filtroprontofibra.tipo.length) && 
          (!this._filtroprontofibra.statoFase1 || !this._filtroprontofibra.statoFase1.length) &&
          (!this._filtroprontofibra.statoFase2 || !this._filtroprontofibra.statoFase2.length) &&
          (!this._filtroprontofibra.statoProntofibra || !this._filtroprontofibra.statoProntofibra.length) &&
          (!this._filtroprontofibra.bando || !this._filtroprontofibra.bando.length) &&
          (!this._filtroprontofibra.regione || !this._filtroprontofibra.regione.length) 
         ){
            this.filterTabellaIsSet = false;
        } 
      }
     }

    filtraPerLotto(lotto:string){
      if(!this.filterTabellaIsSet){
        if(
         (!this._filtroprontofibra.tipo || !this._filtroprontofibra.tipo.length) && 
         (!this._filtroprontofibra.statoFase1 || !this._filtroprontofibra.statoFase1.length) &&
         (!this._filtroprontofibra.statoFase2 || !this._filtroprontofibra.statoFase2.length) &&
         (!this._filtroprontofibra.statoProntofibra || !this._filtroprontofibra.statoProntofibra.length) &&
         (!this._filtroprontofibra.bando || !this._filtroprontofibra.bando.length) &&
         (!this._filtroprontofibra.regione || !this._filtroprontofibra.regione.length) 
       ){
         this.prontofibraDT.filterGlobal(lotto, 'contains');
         this.filterTabellaIsSet = true;
       }
     }else{
       this.prontofibraDT.clear();
       if(
         (!this._filtroprontofibra.tipo || !this._filtroprontofibra.tipo.length) && 
         (!this._filtroprontofibra.statoFase1 || !this._filtroprontofibra.statoFase1.length) &&
         (!this._filtroprontofibra.statoFase2 || !this._filtroprontofibra.statoFase2.length) &&
         (!this._filtroprontofibra.statoProntofibra || !this._filtroprontofibra.statoProntofibra.length) &&
         (!this._filtroprontofibra.bando || !this._filtroprontofibra.bando.length) &&
         (!this._filtroprontofibra.regione || !this._filtroprontofibra.regione.length) 
        ){
           this.filterTabellaIsSet = false;
       } 
     }
    }
    
      
    
    removeFilter(){
      
      if(this.filtroLotto || this.filtroStato  || this.filtroBando || this.filtroPratica){
        this.location.replaceState('/prontofibra');
        
        this.filterIsSet = false;
        this.filtroLotto = null;
        this.filtroStato = null;
        this.filtroBando = null;
        this.filtroInLavorazione = false;
        this.filtroPratica = null;
         this.loadProntofibra();
      }else{

        if(
          this._filtroprontofibra && 
          (this._filtroprontofibra.tipo && this._filtroprontofibra.tipo.length > 0) || 
          (this._filtroprontofibra.statoFase1 && this._filtroprontofibra.statoFase1.length > 0 ) ||
          (this._filtroprontofibra.statoFase2 && this._filtroprontofibra.statoFase2.length > 0 ) ||
          (this._filtroprontofibra.statoProntofibra && this._filtroprontofibra.statoProntofibra.length > 0 ) ||
          (this._filtroprontofibra.regione && this._filtroprontofibra.regione.length > 0 ) ||
          (this._filtroprontofibra.bando && this._filtroprontofibra.bando.length > 0 )  ||
          (this._filtroprontofibra.impresa && this._filtroprontofibra.impresa.length > 0 ) ||
          (this._filtroprontofibra.categoriaAttesa && this._filtroprontofibra.categoriaAttesa.length > 0 )

        ){
          this._filtroprontofibra.tipo                = [];
          this._filtroprontofibra.statoProntofibra    = [];
          this._filtroprontofibra.statoFase1          = [];
          this._filtroprontofibra.statoFase2          = [];
          this._filtroprontofibra.regione             = [];
          this._filtroprontofibra.bando               = null;
          this._filtroprontofibra.impresa   = [];
          this._filtroprontofibra.categoriaAttesa   = [];
          this._filtroprontofibra               = {};
        }
        this.filterTabellaIsSet = false;
        this.prontofibraFiltrati = this.prontofibra;
        this.prontofibraDT.clear(); 
      }
     
     
    }

    mostraprontofibra(oda:OdaAtFirestore, fase:string){

    }

    
    scaricaReportProntofibra(){
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
      this.excelService.exportPFToExcel(this.prontofibraFiltrati, 'prontofibra_'+formattedDate+".xlsx", true);
    }

    

   
    setUserRole(){
      if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "ADMIN"
      ) {
        this.isAdmin = true;
      } else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "SUPERADMIN"
      ) {
        this.isSuperAdmin = true;
      } else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "SMARTFIBER"
      ) {
        this.isPresidioSF = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "PRESIDIO"
      ) {
        this.isPresidioTIM = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
      ) {
        this.isImpresa = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_VERBALI"
      ) {
        this.isDirigenteFirmaVerbali = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_PACCHETTI"
      ) {
        this.isDirigenteFirmaPacchetti = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "PM"
      ) {
        this.isPM = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DEMO"
      ) {
        this.isDemo = true;
      }
    }

    get filtroprontofibra(): FiltroProntofibra {
      return this._filtroprontofibra;
    }
    
    set filtroprontofibra(value: FiltroProntofibra) {
      this._filtroprontofibra = value;
    }
    

    sollecitaFibercop(){
      this.showSollecitaMassivamenteConfirmation = true;
    }

    confermaSollecitaMassivamente(){
      this.isLoadingResults = true;
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
      let pfInAttesaBando1 = this.prontofibraFiltrati.filter(pf => pf.codiceStatoProntofibra === "IN ATTESA" && pf.bando==='BANDO 1' );
      let pfInAttesaBando2 = this.prontofibraFiltrati.filter(pf => pf.codiceStatoProntofibra === "IN ATTESA" && pf.bando==='BANDO 2' );
      this.logger.info(pfInAttesaBando1);
      this.logger.info(pfInAttesaBando2);
      let fileNameBando1 = 'pf_bando1_in_attesa_'+formattedDate+".xlsx";
      let fileNameBando2 = 'pf_bando2_in_attesa_'+formattedDate+".xlsx";

      let blobBando1 = this.excelService.exportPFToExcel(pfInAttesaBando1,fileNameBando1 , false);
      let blobBando2 = this.excelService.exportPFToExcel(pfInAttesaBando2,fileNameBando2 , false);
      const fileBando1 = new File([blobBando1], fileNameBando1, { type: blobBando1.type });
      const fileBando2 = new File([blobBando2], fileNameBando2, { type: blobBando2.type });

      const sollecitoBando1$ = fileBando1 ? this.prontofibraService.sollecitaMassivamente(fileBando1, pfInAttesaBando1.length.toString(), '1') : null;
      const sollecitoBando2$ = fileBando2 ? this.prontofibraService.sollecitaMassivamente(fileBando2, pfInAttesaBando2.length.toString(),'2') : null;

      forkJoin([sollecitoBando1$, sollecitoBando2$]).subscribe({
        next: () => {
          this.logger.info("--NEXT");
          this.isLoadingResults = false;
          this.showSollecitaMassivamenteConfirmation = false;
          this.messageService.add({ severity: 'success', summary: '', detail: 'Sollecito massivo inviato!', life: 5000 });
        },
        error: (e) => {
          this.isLoadingResults = false;
          this.showSollecitaMassivamenteConfirmation = false;
          this.messageService.add({ life: 10000, severity: 'error', summary: 'Errore', detail: 'Errore in fase di invio del sollecito massivo' });
        },
        complete:()=>{
          this.logger.info("--COMPLETE");
        }
      });
      
      
    }
  }
